<template>
    <CardSelectItem :key="availablePaymentType.id"
                    :icon="icon"
                    :value="availablePaymentType.id">
        {{availablePaymentType.type.name.charAt(0).toUpperCase() + availablePaymentType.type.name.slice(1).toLowerCase()}}
    </CardSelectItem>
</template>

<script>

export default {
    name: "AvailablePaymentTypeCardSelectItem",
    props: {
        availablePaymentType: {
            type: Object,
            required: true
        }
    },
    computed: {
        icon() {
            switch (this.availablePaymentType.type.id) {
                case 1:
                    return "credit-card"
                case 2:
                    return "file-invoice"
                case 3:
                    return ['fab', 'paypal']
                case 4:
                    return "coins"
            }
        }
    }
}
</script>

<style scoped>

</style>
